const referencias = [
  {
    operacao: "eq",
    titulo: "Espera que seja igual à",
    perguntaTipos: ["sim_nao", "decimal", "integer"],
    validacao: (esperado, valor) => esperado === valor,
  },
  {
    operacao: "not_eq",
    titulo: "Espera que seja diferente de",
    perguntaTipos: ["sim_nao", "decimal", "integer"],
    validacao: (esperado, valor) => esperado !== valor,
  },
  {
    operacao: "between",
    titulo: "Espera que esteja dentro do intervalo",
    perguntaTipos: ["decimal", "integer"],
    validacao: ([min, max], valor) => min <= valor && max >= valor,
  },
  {
    operacao: "not_between",
    titulo: "Espera que esteja fora do intervalo",
    perguntaTipos: ["decimal", "integer"],
    validacao: ([min, max], valor) => min >= valor && max <= valor,
  },
  {
    operacao: "in",
    titulo: "Espera que esteja dentro de",
    perguntaTipos: ["decimal", "integer", "radio", "checkbox"],
    validacao: (arrEsperado, valor) => arrEsperado.includes(valor),
  },
  {
    operacao: "not_in",
    titulo: "Espera que esteja fora de",
    perguntaTipos: ["decimal", "integer", "radio", "checkbox"],
    validacao: (arrEsperado, valor) => !arrEsperado.includes(valor),
  },
]

export const referenciasPorPerguntaTipo = tipo =>
  referencias.filter(referencia => referencia.perguntaTipos.includes(tipo))

export default referencias
